module.exports = __webpack_public_path__ + "img/archery-arrow.b041acaf.svg";